import React from 'react'
import "./UnderNegotiation.css"

const UnderNegotiation = () => {
  return (
    <div>UnderNegotiation</div>
  )
}

export default UnderNegotiation